import React, { useEffect } from 'react';
import imgavatar from '../assets/images/asset1.png';
import imgavatar3 from '../assets/images/avatar3.png';
import imgavatar2 from '../assets/images/construction.png';

const Carousel = () => {
    useEffect(() => {
        import('bootstrap/dist/js/bootstrap.bundle.min').then((bootstrap) => {
            const carouselElement = document.getElementById('hiroHeaderCarousel');
            if (carouselElement) {
                new bootstrap.Carousel(carouselElement, {
                    interval: 3500,
                    ride: 'carousel'
                });
            }
        });
    }, []);

    return (
        <div className="container wow fadeInUp" >
            <div id="hiroHeaderCarousel" className="hiro-header-carousel carousel slide" data-bs-ride="carousel" data-bs-interval="3500">
                <div className="carousel-inner" role="listbox">
                    <div className="carousel-item active">
                        <div className="row">
                            <div className="col-md-6">
                                <h1 className="carousel-item-title" data-animation="animated fadeInRight" data-number="01"><span>Connecting Jobs with Workers</span></h1>
                                <p className="carousel-item-description" data-animation="animated fadeInRight">Wala Work helps businesses find workers. Our easy-to-use app makes hiring fast and simple.</p>
                                <a href="#!" className="carousel-item-link link-hover-fx" data-animation="animated fadeInRight">READ MORE</a>
                                {/* <ul className="carousel-item-social-links nav" data-animation="animated fadeInRight">
                                    <li><a href="#!" className="link-hover-fx">FACEBOOK</a></li>
                                    <li><a href="#!" className="link-hover-fx">TWITTER</a></li>
                                    <li><a href="#!" className="link-hover-fx">BEHANCE</a></li>
                                </ul> */}
                            </div>
                            <div className="col-md-6">
                                <img src={imgavatar} alt="Remarkable Digital Products" className="img-fluid w-100 rounded" width="372px" />
                            </div>
                        </div>
                    </div>
                    <div className="carousel-item">
                        <div className="row">
                            <div className="col-md-6">
                                <h1 className="carousel-item-title" data-animation="animated fadeInRight" data-number="02"><span>Why Wala Work</span></h1>
                                <p className="carousel-item-description" data-animation="animated fadeInRight">Wala Work saves you time and effort in finding reliable workers. Whether you need temporary staff or long-term employees, Wala Work is here to help.</p>
                                <a href="#!" className="carousel-item-link link-hover-fx" data-animation="animated fadeInRight">READ MORE</a>
                                {/* <ul className="carousel-item-social-links nav" data-animation="animated fadeInRight">
                                    <li><a href="#!" className="link-hover-fx">FACEBOOK</a></li>
                                    <li><a href="#!" className="link-hover-fx">TWITTER</a></li>
                                    <li><a href="#!" className="link-hover-fx">BEHANCE</a></li>
                                </ul> */}
                            </div>
                            <div className="col-md-6">
                                <img src={imgavatar2} alt="Remarkable Digital Products" className="img-fluid w-100 rounded" width="372px" />
                            </div>
                        </div>
                    </div>
                    <div className="carousel-item">
                        <div className="row">
                            <div className="col-md-6">
                                <h1 className="carousel-item-title" data-animation="animated fadeInRight" data-number="03"><span>How It Works</span></h1>
                                <div className="carousel-item-description" data-animation="animated fadeInRight">
                                    <ol>
                                        <li><strong>Post a Job:</strong> Create a job listing with your requirements.</li>
                                        <li><strong>Find a Worker:</strong> Browse through profiles and find the right match.</li>
                                        <li><strong>Hire:</strong> Quickly hire and onboard your chosen worker.</li>
                                        <li><strong>Get to Work:</strong> Start working with your new hire right away.</li>
                                    </ol>
                                </div>
                                <a href="#!" className="carousel-item-link link-hover-fx" data-animation="animated fadeInRight">READ MORE</a>
                                {/* <ul className="carousel-item-social-links nav" data-animation="animated fadeInRight">
                                    <li><a href="#!" className="link-hover-fx">FACEBOOK</a></li>
                                    <li><a href="#!" className="link-hover-fx">TWITTER</a></li>
                                    <li><a href="#!" className="link-hover-fx">BEHANCE</a></li>
                                </ul> */}
                            </div>
                            <div className="col-md-6">
                                <img src={imgavatar3} alt="Remarkable Digital Products" className="img-fluid w-100 rounded" width="372px" />
                            </div>
                        </div>
                    </div>
                </div>
                <ol className="carousel-indicators">
                    <li data-bs-target="#hiroHeaderCarousel" data-bs-slide-to="0" className="active"></li>
                    <li data-bs-target="#hiroHeaderCarousel" data-bs-slide-to="1"></li>
                    <li data-bs-target="#hiroHeaderCarousel" data-bs-slide-to="2"></li>
                </ol>
            </div>
        </div>
    );
};

export default Carousel;
